module.exports = __webpack_public_path__ + "img/logo.2757d93b.png";